import { render, staticRenderFns } from "./JoinPointSocialContainer.vue?vue&type=template&id=4e21ea8f&scoped=true&"
import script from "./JoinPointSocialContainer.vue?vue&type=script&lang=js&"
export * from "./JoinPointSocialContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e21ea8f",
  null
  
)

export default component.exports